const config = {
  baseApi: process.env.REACT_APP_BASE_URL || 'https://api.sourceseas.com/v1/',
  baseImage: process.env.REACT_APP_IMAGE_URL || 'https://api.sourceseas.com/',
};

export default config;
